import { Link } from 'react-router-dom';

interface IBreadcrumbItem {
  text: string;
  url?: string;
}

function Breadcumb({ items }: { items: IBreadcrumbItem[] }) {
  return (
    <nav aria-label="breadcrumb">
      <ol className="breadcrumb">
        {items.map((item) => (
          <li key={item.text} className={item.url ? 'breadcrumb-item' : 'breadcrumb-item active'} aria-current={item.url ? undefined : 'page'}>
            {item.url && <Link to={item.url}>{item.text}</Link>}
            {!item.url && item.text}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default Breadcumb;
